/** Client-side checks only; server must enforce full validation. */
export const MAX_PDF_UPLOAD_BYTES = 25 * 1024 * 1024;

const PDF_MIME_TYPES = new Set(['application/pdf', 'application/x-pdf']);

/**
 * @param {File} file
 * @returns {string|null} Error message, or null if the file passes basic checks.
 */
export function getPdfUploadClientError(file) {
  if (!file || !(file instanceof File)) {
    return 'Please choose a file to upload.';
  }
  if (file.size > MAX_PDF_UPLOAD_BYTES) {
    return 'File size must not exceed 25 MB.';
  }
  const lowerName = String(file.name || '').toLowerCase();
  if (!lowerName.endsWith('.pdf')) {
    return 'Only PDF files are supported.';
  }
  if (file.type && !PDF_MIME_TYPES.has(file.type)) {
    return 'Only PDF files are supported.';
  }
  return null;
}
